import React, { useEffect, useState } from 'react'
import usePagamento from 'src/hooks/usePagamento'
import UBox from '../ui/Ubox'
import {
  Grid,
  LinearProgress,
  Tooltip,
  Typography,
  withStyles,
  makeStyles,
  useTheme,
  useMediaQuery
} from '@material-ui/core'
import formatarDinheiro from 'src/core/formatacoes/formatarDinheiro'
import {
  Etapa,
  StatusEtapaEnum,
  obterEtapasParaExibir as obterEtapasDoResumo
} from 'src/api/pagamento'
import { AiOutlineCheck, AiOutlineRight } from 'react-icons/ai'

const useStyles = makeStyles(() => ({
  barraComListras: {
    backgroundColor: '#1cc3a5',
    position: 'relative',
    overflow: 'visible',
    minWidth: '6px',
    height: '12px',
    borderTopLeftRadius: '4px',
    borderBottomLeftRadius: '4px',
    borderTopRightRadius: '4px',
    borderBottomRightRadius: '4px',
    transition: 'width 2.0s ease-out',
    backgroundImage: `linear-gradient(
      -45deg,
      transparent 30%,
      rgba(255,255,255,0.25) 30%,
      rgba(255,255,255,0.25) 50%,
      transparent 50%,
      transparent 70%,
      rgba(255,255,255,0.25) 70%
    )`,
    backgroundSize: '10px 10px',
    animation: '$listrasMovimento 1.6s linear infinite',
    '&.done': {
      backgroundColor: '#1cc3a5',
      animation: 'none',
      backgroundImage: 'none'
    },
    '&.pending': {
      backgroundColor: '#1cc3a5',
      animation: '$listrasMovimento 1.6s linear infinite'
    }
  },
  '@keyframes listrasMovimento': {
    '0%': { backgroundPosition: '0 0' },
    '100%': { backgroundPosition: '10px 10px' }
  },
  pontaDiagonal: {
    position: 'absolute',
    top: 0,
    right: '-1px',
    width: '6px',
    height: '12px',
    backgroundColor: '#1cc3a5',
    transform: 'skewX(-15deg)',
    borderTopRightRadius: '0px',
    borderBottomRightRadius: '0px',
    borderBottomLeftRadius: '4px',
    transition: 'right 0.8s ease-out',
    backgroundImage: `linear-gradient(
      -45deg,
      transparent 30%,
      rgba(255,255,255,0.25) 30%,
      rgba(255,255,255,0.25) 50%,
      transparent 50%,
      transparent 70%,
      rgba(255,255,255,0.25) 70%
    )`,
    backgroundSize: '10px 10px',
    animation: '$listrasMovimento 1.6s linear infinite'
  },
  graficoContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '24px',
    padding: '8px 4px 16px',
    '&.xs': {
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      gap: '12px'
    }
  },
  graficoDisco: {
    width: 96,
    height: 96,
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    // backgroundColor: '#ffffff',
    position: 'relative'
  },
  graficoDiscoValor: {
    fontSize: 26,
    fontWeight: 700,
    color: '#1cc3a5',
    lineHeight: 0.9
  },
  graficoDiscoLegenda: {
    fontSize: 10,
    marginTop: 1,
    color: '#444',
    textAlign: 'center',
    lineHeight: 0.9,
    fontWeight: 500
  },
  graficoBarrasContainer: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    gap: 6,
    '&.xs': {
      width: '100%',
      alignItems: 'center',
      justifyContent: 'center'
    }
  },
  graficoBarraLinha: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '4px 8px',
    backgroundColor: '#fbfbfb',
    borderRadius: 4,

    gap: 8,
    '.xs &': {
      width: '100%',
      flexDirection: 'column',
      alignItems: 'flex-start',
      justifyContent: 'center',
      paddingBottom: 14
      // gap: 0
      // padding: '0 0 8px',
      // backgroundColor: 'transparent'
    }
  },
  graficoBarraLabel: {
    width: 160
  },
  graficoBarraValor: {
    fontSize: 11,
    color: '#444',
    marginLeft: 8
  },
  graficoBarraTrilho: {
    flex: 1,
    height: 8,
    borderRadius: 4,
    backgroundColor: '#e0e0e0',
    '.xs &': {
      width: '100%'
    }

    // overflow: 'hidden'
  },
  graficoBarraPreenchimento: {
    height: '100%',
    borderRadius: 4,
    backgroundColor: '#1cc3a5',
    transition: 'right 0.8s ease-out, width 1.6s ease-out',
    backgroundImage: `linear-gradient(
      -45deg,
      transparent 30%,
      rgba(255,255,255,0.25) 30%,
      rgba(255,255,255,0.25) 50%,
      transparent 50%,
      transparent 70%,
      rgba(255,255,255,0.25) 70%
    )`,
    backgroundSize: '10px 10px',
    animation: '$listrasMovimento 1.6s linear infinite',
    '&.done': {
      backgroundColor: '#1cc3a5',
      animation: 'none',
      backgroundImage: 'none'
    },
    '&.pending': {
      backgroundColor: '#1cc3a5',
      animation: '$listrasMovimento 1.6s linear infinite'
    }
  },
  resumoCardsContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'stretch',
    justifyContent: 'space-between',
    gap: '12px',
    flexWrap: 'wrap',
    flex: '1 1 25%',
    '.xs &': {
      flex: '1 1 50%'
    }
  },
  resumoCard: {
    flex: 1,
    backgroundColor: '#ffffff',
    borderRadius: 4,
    padding: '8px 10px',
    border: '1px solid #eee',
    textAlign: 'center'
  },
  resumoCardTitulo: {
    fontWeight: 400,
    fontSize: '12px'
  },
  resumoCardValor: {
    fontWeight: 500
  }
}))

interface IPropsProgressoPagamento {
  ignorarProvisoria?: boolean
}
export default function ProgressoPagamento({
  ignorarProvisoria = false
}: IPropsProgressoPagamento) {
  const classes = useStyles()
  const { resumo, etapaAtual } = usePagamento()
  const theme = useTheme()
  const ehXS = useMediaQuery(theme.breakpoints.down('xs'))
  const etapaAtualIndex = etapaAtual
    ? obterEtapasParaExibir().findIndex(
        etapa => etapa.titulo === etapaAtual.titulo
      )
    : 0
  const valorTotal = etapaAtual ? etapaAtual.valor : resumo?.valorTotal
  const valorPago = etapaAtual ? etapaAtual.valorPago : resumo?.valorPago
  const labelValorTotal = etapaAtual
    ? `Valor da ${etapaAtual.titulo?.toLowerCase()}`
    : 'Valor da proposta'

  function obterPorcentagemValorPago(): number {
    if (!valorTotal || valorTotal === 0) return 0
    var porcentagem = (valorPago / valorTotal) * 100
    return porcentagem
  }

  function obterPorcentagemValorTotalPago(): number {
    if (!resumo.valorTotal || resumo.valorTotal === 0) return 0
    var porcentagem = (resumo.valorPago / resumo.valorTotal) * 100
    return porcentagem
  }

  function obterEtapasParaExibir(): Etapa[] {
    if (ignorarProvisoria) {
      return resumo?.etapas
    }

    return obterEtapasDoResumo(resumo)
  }

  if (resumo?.versaoPagamento === 'v2.1') {
    return (
      <UBox
        style={{
          backgroundColor: '#f5f5f5',
          padding: '16px 16px',
          borderRadius: '4px',
          marginBottom: '16px'
        }}
      >
        <Typography variant="body2" color="primary" align="center">
          Seu pagamento foi dividido em{' '}
          <b>{obterEtapasParaExibir().length} etapas</b>
          {/* <small>
            A proposta de <b>{formatarDinheiro(resumo.valorTotal)}</b>
            {' foi dividido em '}
            <b>{resumo.etapas.length}</b> etapas
          </small>
          <br />
          <small>
            Você está na etapa
            <b>{` ${etapaAtualIndex + 1} - ${etapaAtual?.titulo}`}</b>
          </small> */}
        </Typography>
        <div className={`${classes.graficoContainer} ${ehXS ? 'xs' : ''}`}>
          <div>
            <div className={classes.graficoDisco}>
              <svg
                width={96}
                height={96}
                viewBox="0 0 96 96"
                style={{ position: 'absolute', top: 0, left: 0, zIndex: 2 }}
              >
                {(() => {
                  const raio = 42
                  const circunferencia = 2 * Math.PI * raio
                  const [porcentagem, setPorcentagem] = useState(0.1)
                  useEffect(() => {
                    setTimeout(() => {
                      setPorcentagem(
                        Math.max(
                          0,
                          Math.min(100, obterPorcentagemValorTotalPago() || 0.1)
                        )
                      )
                    }, 600)
                  }, [porcentagem])
                  const offset =
                    circunferencia - (porcentagem / 100) * circunferencia
                  return (
                    <>
                      <circle
                        cx="48"
                        cy="48"
                        r={raio}
                        stroke="#e0e0e0"
                        strokeWidth="8"
                        fill="none"
                      />
                      <circle
                        cx="48"
                        cy="48"
                        r={raio}
                        stroke="#1cc3a5"
                        strokeWidth="10"
                        fill="none"
                        strokeDasharray={circunferencia}
                        strokeDashoffset={offset}
                        strokeLinecap="round"
                        transform="rotate(-90 48 48)"
                        style={{
                          transition: 'stroke-dashoffset 1.6s ease-out'
                        }}
                      />
                    </>
                  )
                })()}
              </svg>
              <div
                style={{
                  textAlign: 'center',
                  zIndex: 1,
                  borderRadius: '50%',
                  backgroundColor: '#fff',
                  width: '90px',
                  height: '90px',
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}
              >
                <div className={classes.graficoDiscoValor}>
                  {obterPorcentagemValorTotalPago().toFixed(0)}
                </div>
                <div className={classes.graficoDiscoLegenda}>
                  % do valor
                  <br />
                  pago
                </div>
              </div>
            </div>
            {/* <Typography
              variant="body2"
              color="primary"
              style={{ margin: '8px 4px', fontSize: '10px' }}
              align="center"
            >
              Valor da cirurgia:
              <br />
              <b>{formatarDinheiro(resumo.valorTotal)}</b>
            </Typography> */}
          </div>
          <div
            className={`${classes.graficoBarrasContainer} ${ehXS ? 'xs' : ''}`}
          >
            {obterEtapasParaExibir().map((etapa, index) => {
              const ehEtapaAtual = etapa?.titulo === etapaAtual?.titulo
              const ehEtapaPaga = etapa?.status === StatusEtapaEnum.Pago
              // const porcentagemEtapa = (etapa?.valor / resumo.valorTotal) * 100
              const constantePorcentagemEtapaPaga =
                (etapa?.valorPago / etapa?.valor) * 100
              const [porcentagemEtapaPaga, setPorcentagemEtapaPaga] = useState(
                ehEtapaAtual ? 0 : constantePorcentagemEtapaPaga
              )
              useEffect(() => {
                if (ehEtapaAtual) {
                  setTimeout(() => {
                    setPorcentagemEtapaPaga(constantePorcentagemEtapaPaga)
                  }, 600)
                }
              }, [porcentagemEtapaPaga, resumo])

              return (
                <div
                  key={etapa.titulo}
                  className={classes.graficoBarraLinha}
                  style={{
                    opacity: ehEtapaAtual ? 1 : 0.5,
                    border: ehEtapaAtual ? '1px solid rgb(178 233 223)' : 'none'
                  }}
                >
                  <Typography
                    variant="body2"
                    color={ehEtapaAtual ? 'primary' : 'textSecondary'}
                    className={classes.graficoBarraLabel}
                    style={{ fontSize: '10px' }}
                  >
                    <small>Etapa {index + 1}</small>
                    <br />
                    <b>{etapa.titulo}</b>
                  </Typography>
                  <div
                    style={{
                      width: '100%',
                      display: 'flex',
                      flexDirection: 'row',
                      alignItems: 'center',
                      justifyContent: 'center',
                      gap: 8
                    }}
                  >
                    <div
                      className={classes.graficoBarraTrilho}
                      style={{
                        position: 'relative'
                      }}
                    >
                      <div
                        className={`${classes.graficoBarraPreenchimento} ${
                          ehEtapaPaga ? 'done' : 'pending'
                        }`}
                        style={{
                          width:
                            porcentagemEtapaPaga > 0
                              ? `${porcentagemEtapaPaga}%`
                              : '8px'
                        }}
                      />
                      <div
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'space-between',
                          width: '100%',
                          position: 'absolute',
                          top: '8px',
                          left: 0,
                          zIndex: 1,
                          fontSize: '10px'
                        }}
                      >
                        <span>{formatarDinheiro(etapa.valorPago)}</span>
                        <span>{formatarDinheiro(etapa.valor)}</span>
                      </div>
                    </div>
                    <span className={classes.graficoBarraValor}>
                      {porcentagemEtapaPaga.toFixed(0)} / 100
                    </span>
                  </div>
                </div>
              )
            })}
          </div>
        </div>
        <div className={classes.resumoCardsContainer}>
          <UBox className={classes.resumoCard}>
            <Typography
              variant="body2"
              color="textSecondary"
              className={classes.resumoCardTitulo}
            >
              Valor total da cirurgia
            </Typography>
            <Typography
              variant="body2"
              className={classes.resumoCardValor}
              color="primary"
            >
              {formatarDinheiro(resumo.valorTotal)}
            </Typography>
          </UBox>
          <UBox className={classes.resumoCard}>
            <Typography
              variant="body2"
              color="textSecondary"
              className={classes.resumoCardTitulo}
            >
              Pago
            </Typography>
            <Typography
              variant="body2"
              className={classes.resumoCardValor}
              color="primary"
            >
              {formatarDinheiro(resumo.valorPago)}
            </Typography>
          </UBox>
          <UBox className={classes.resumoCard}>
            <Typography
              variant="body2"
              color="textSecondary"
              className={classes.resumoCardTitulo}
            >
              Em processamento
            </Typography>
            <Typography
              variant="body2"
              className={classes.resumoCardValor}
              color="primary"
            >
              {formatarDinheiro(resumo.valorEmProcessamento)}
            </Typography>
          </UBox>
          <UBox className={classes.resumoCard}>
            <Typography
              variant="body2"
              color="textSecondary"
              className={classes.resumoCardTitulo}
            >
              Valor restante
            </Typography>
            <Typography
              variant="body2"
              className={classes.resumoCardValor}
              color="error"
              style={{ color: '#f27474' }}
            >
              {formatarDinheiro(resumo.saldoDevedor)}
            </Typography>
          </UBox>
        </div>
      </UBox>
    )
  }

  return (
    <UBox mb={2}>
      {etapaAtual && (
        <Typography
          variant="body2"
          style={{ fontWeight: 600, marginBottom: 4 }}
        >
          {`${obterPorcentagemValorPago().toFixed(0)}% do valor da `}
          <b>{etapaAtual.titulo?.toLowerCase()}</b>
          {' pago'}
        </Typography>
      )}
      {!etapaAtual && (
        <small>
          {`${obterPorcentagemValorPago().toFixed(2)}% do valor já pago`}
        </small>
      )}
      <Tooltip
        title={`${obterPorcentagemValorPago().toFixed(2)}% do valor processado`}
      >
        <BorderLinearProgress
          variant="determinate"
          value={obterPorcentagemValorPago()}
          title={`${obterPorcentagemValorPago().toFixed(
            2
          )}% do valor processado`}
        />
      </Tooltip>
      <Grid container>
        <Grid item xs={6}>
          <UBox
            style={{
              display: 'flex',
              alignItems: 'start',
              gap: '8px',
              marginTop: '4px',
              lineHeight: 1.1
            }}
          >
            <UBox
              style={{
                background: '#1cc3a5',
                width: '8px',
                height: '8px',
                borderRadius: '50%',
                marginTop: '4px'
              }}
            />
            <small>
              Pagamentos
              <br />
              <b>{formatarDinheiro(valorPago)}</b>
            </small>
          </UBox>
        </Grid>
        <Grid item xs={6} style={{ textAlign: 'right' }}>
          <UBox
            style={{
              marginTop: '4px',
              lineHeight: 1.1
            }}
          >
            <small>
              {labelValorTotal}
              <br />
              <b>{formatarDinheiro(valorTotal)}</b>
            </small>
          </UBox>
        </Grid>
      </Grid>
    </UBox>
  )
}

export const BorderLinearProgress = withStyles(theme => ({
  root: {
    height: 8,
    borderRadius: 4
  },
  colorPrimary: {
    backgroundColor:
      theme.palette.grey[theme.palette.type === 'light' ? 200 : 700]
  },
  bar: {
    borderRadius: 5,
    backgroundColor: '#1cc3a5'
  }
}))(LinearProgress)
